module.exports = __webpack_public_path__ + "img/istruzioni_singolo_referto.81b0ef86.png";